import { motion } from 'framer-motion'; // 페이지 애니메이션 (없애면 motion.div도 함께 삭제)
import { useEffect, useState } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import AdminResponses from './pages/AdminResponses';
import AdminSurveyManagePage from './pages/AdminSurveyManagePage';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import LoginNoticeManager from './pages/LoginNoticeManager';
import LoginRoute from './pages/LoginRoute';
import './pages/pages.css'; // 스타일 추가
import Result from './pages/Result';
import SiteManager from './pages/SiteManager';
import UserManager from './pages/UserManager';
import UserSurveyPage from './pages/UserSurveyPage';

function App() {

  // 폰트 사이즈 조절
  const [fontSize, setFontSize] = useState(16); // 기본값

    // 🔁 마운트 시 로컬스토리지에서 값 불러오기
  useEffect(() => {
    const savedSize = localStorage.getItem('fontSize');
    if (savedSize) {
      setFontSize(parseInt(savedSize, 10));
    }
  }, []);

  // ✅ 폰트 사이즈 -, = 상태가 바뀔 때마다 저장
  useEffect(() => {
    localStorage.setItem('fontSize', fontSize);
  }, [fontSize]);

  return (
    
    <div style={{ fontSize: `${fontSize}px` }}>
      {/* ✅ 전역 위치에 고정 버튼 추가 */}
      <div className="global-controls" style={{ fontSize: `${fontSize}px` }}>
        <button onClick={() => setFontSize((prev) => Math.max(prev - 2, 10))}>A-</button>
        <button onClick={() => setFontSize(16)}>A</button>
        <button onClick={() => setFontSize((prev) => Math.min(prev + 2, 30))}>A+</button>
      </div>


      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={
            <LoginRoute allowedRole="admin" redirectTo="/">
              <Dashboard fontSize={fontSize} />
            </LoginRoute>
          } />
          <Route path="/admin/login-notice" element={
            <LoginRoute allowedRole="admin" redirectTo="/">
              <LoginNoticeManager />
            </LoginRoute>
          } />

          <Route path="/survey" element={
            <LoginRoute allowedRole="user" redirectTo="/">
              <motion.div
                initial={{ opacity: 0 }} // 시작 시 투명도 0
                animate={{ opacity: 1 }} // 애니메이션 후 투명도 1
                exit={{ opacity: 0 }} // 나갈 때 투명도 0
                transition={{
                  duration: 0.2, // 애니메이션 시간 0.5초
                  ease: "easeInOut", // 애니메이션의 easing
                }}
              >
                <UserSurveyPage fontSize={fontSize} setFontSize={setFontSize} />
              </motion.div>
            </LoginRoute>
          } />

          <Route path="/admin" element={
            <LoginRoute allowedRole="admin" redirectTo="/">
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{
                  duration: 0.2, // 애니메이션 시간 0.5초
                  ease: "easeInOut", // 애니메이션의 easing
                }}
              >
                <AdminSurveyManagePage fontSize={fontSize} setFontSize={setFontSize} />
              </motion.div>
            </LoginRoute>
          } />

          <Route path="/results" element={
            <LoginRoute allowedRole="admin" redirectTo="/">
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{
                  duration: 0.2, // 애니메이션 시간 0.5초
                  ease: "easeInOut", // 애니메이션의 easing
                }}
              >
                <Result fontSize={fontSize} setFontSize={setFontSize} />
              </motion.div>
            </LoginRoute>
          } />

          <Route path="/responses" element={
            <LoginRoute allowedRole="admin" redirectTo="/">
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{
                  duration: 0.2, // 애니메이션 시간 0.5초
                  ease: "easeInOut", // 애니메이션의 easing
                }}
              >
                <AdminResponses fontSize={fontSize} setFontSize={setFontSize} />
              </motion.div>
            </LoginRoute>
          } />

          <Route path="/user" element={
            <LoginRoute allowedRole="admin" redirectTo="/">
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{
                  duration: 0.2, // 애니메이션 시간 0.5초
                  ease: "easeInOut", // 애니메이션의 easing
                }}
              >
                <UserManager fontSize={fontSize} setFontSize={setFontSize} />
              </motion.div>
            </LoginRoute>
          } />

          <Route path="/site" element={
            <LoginRoute allowedRole="admin" redirectTo="/">
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{
                  duration: 0.2, // 애니메이션 시간 0.5초
                  ease: "easeInOut", // 애니메이션의 easing
                }}
              >
                <SiteManager fontSize={fontSize} setFontSize={setFontSize} />
              </motion.div>
            </LoginRoute>
          } />

        </Routes>

        
      </Router>



    </div>
  );
}

export default App;
